import { render } from "./QuestionOrderElementsQuiz.vue?vue&type=template&id=6d4500c4&scoped=true"
import script from "./QuestionOrderElementsQuiz.vue?vue&type=script&lang=js"
export * from "./QuestionOrderElementsQuiz.vue?vue&type=script&lang=js"

import "./QuestionOrderElementsQuiz.vue?vue&type=style&index=0&id=6d4500c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4500c4"]])

export default __exports__